/**
 * AEON Main Entry Point
 * Orquesta la inicialización de módulos y el sistema de hidratación de islas.
 */

import { initResilience, withErrorBoundary } from '../assets/js/modules/resilience.js';
import { initOrchestrator } from '../assets/js/modules/orchestrator.js';
import { initPredictive } from '../assets/js/modules/predictive.js';
import * as analytics from '../assets/js/modules/analytics.js';

// Mapa de componentes estáticos (no hidratados dinámicamente)
const staticComponents = {
    'forms': () => import('../assets/js/modules/forms.js'),
    'ui': () => import('../assets/js/modules/ui.js'),
    'carousel': () => import('../assets/js/modules/carousel.js'),
    'lightbox': () => import('../assets/js/modules/lightbox.js')
};

async function init() {
    // 1. Activar protecciones globales
    initResilience();
    
    // 2. Activar orquestador de islas (Partial Hydration)
    initOrchestrator();

    // 3. Activar Experiencia Predictiva (Hover-Intent)
    initPredictive();

    console.debug('🚀 [System] Initializing Staff Component Loader...');

    // 3. Inicializar componentes estáticos que no requieren hidratación lazy
    const components = document.querySelectorAll('[data-component]:not([data-hydrate])');
    
    for (const el of components) {
        const componentNames = el.getAttribute('data-component').split(' ');
        for (const name of componentNames) {
            if (staticComponents[name]) {
                await withErrorBoundary(name, async () => {
                    const module = await staticComponents[name]();
                    if (module.default) module.default(el);
                });
            }
        }
    }

    // 4. Inicializar Analytics si está habilitado
    if (document.body.hasAttribute('data-analytics')) {
        analytics.init();
    }

    // 5. Soporte para imágenes Lazy (Fallback)
    const lazyImageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.style.opacity = '1';
                const skeleton = img.closest('.skeleton-shimmer');
                if (skeleton) {
                    setTimeout(() => {
                        skeleton.style.background = 'none';
                        skeleton.classList.remove('skeleton-shimmer');
                    }, 300);
                }
                observer.unobserve(img);
            }
        });
    }, { rootMargin: '50px' });

    document.querySelectorAll('img.lazy-image').forEach(img => lazyImageObserver.observe(img));
}

// Bootstrapping
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
